import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

export function DisplayContentFooter({
  children,
  ...props
}: PropsWithChildren<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>) {
  return (
    <div
      {...props}
      style={{
        paddingBottom: '50px',
        ...props.style,
      }}>
      {children}
    </div>
  );
}
